











import Vue from "vue";
import Component from "vue-class-component";
import { PAYS } from "../logic/enums";
import { enumToOptions } from "../logic/utils";

const PaysFieldProps = Vue.extend({
  props: {
    pays: String
  },
  model: {
    prop: "pays",
    event: "change"
  }
});

@Component({})
export default class PaysField extends PaysFieldProps {
  options = enumToOptions(PAYS);
}
